module.exports = __webpack_public_path__ + "static/media/mrhIconFaq.6957e90c.svg";